<div class="ng-autocomplete">
	<ng-autocomplete
		#autoComplete
		class="input-autocomplete"
		[class.input-error]="inputStatus === 'error'"
		[data]="data"
		[initialValue]="bankSelected"
		[searchKeyword]="search"
		placeholder="{{ 'GENERAL.BANKNAME' | translate }}"
		(selected)="selectEvent($event)"
		(inputCleared)="onClearBankSelected()"
		(closed)="onCloseInput()"
		(inputChanged)="currentSearchValue = $event"
		[notFoundText]="'GENERAL.BANKNOTFOUND' | translate"
		historyIdentifier="data"
		[itemTemplate]="itemTemplate"
		[historyHeading]="null"
		[historyIdentifier]="null"
		[notFoundTemplate]="notFoundTemplate"
	>
	</ng-autocomplete>

	<ng-template #itemTemplate let-item>
		<div class="bankData">
			<span class="bankIspb">&nbsp;{{ item.code }}</span>
			<span class="bankName" [innerHTML]="item.fullName | uppercase"></span>
		</div>
	</ng-template>

	<ng-template #notFoundTemplate let-notFound>
		<div [innerHTML]="notFound"></div>
	</ng-template>
</div>
